<template>
  <v-dialog v-model="isActive" max-width="600px" persistent>
    <v-card>
      <v-card-title class="headline">
        <v-icon class="mr-2">mdi-lock-reset</v-icon>
        Reset PIN - Select the preferred notification Channel
      </v-card-title>

      <v-card-text>
        <!-- Email Option -->
        <v-card class="mb-3" outlined>
          <v-card-text>
            <v-row align="center">
              <v-col cols="2">
                <v-icon size="30" :color="emailAvailable ? 'primary' : 'grey'">
                  mdi-email
                </v-icon>
              </v-col>
              <v-col cols="7">
                <div class="subtitle-1">Email</div>
                <div class="caption" v-if="emailAvailable">{{ user.email }}</div>
                <div class="caption text--disabled" v-else>Email unavailable</div>
              </v-col>
              <v-col cols="3">
                <v-btn
                  color="primary"
                  class="mr-2 ml-3"
                  :disabled="!emailAvailable || isLoading"
                  :loading="isLoading && selectedChannel === 'email'"
                  @click="sendReset('email')"
                >
                  Send via Email
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>

        <!-- Phone Numbers Section -->
        <v-card outlined v-if="user.phone_number != null">
          <v-card-text>
            <div class="subtitle-1 mb-3">
              <v-icon class="mr-2">mdi-phone</v-icon>
              Phone Number
            </div>

            <v-row align="center">
              <v-col cols="5">
                <div class="body-2">{{ user.full_phone_number }}</div>
                <div class="caption text--secondary">{{ "Mobile" }}</div>
              </v-col>
              <v-col cols="7">
                <v-btn
                  color="success"
                  class="mr-2"
                  :disabled="isLoading"
                  :loading="
                    isLoading &&
                    selectedChannel === 'sms' &&
                    selectedPhone === user.full_phone_number
                  "
                  @click="sendReset('sms', user.full_phone_number)"
                  small
                >
                  <v-icon small class="mr-1">mdi-message-text</v-icon>
                  SMS
                </v-btn>
                <v-btn
                  color="green darken-1"
                  :disabled="isLoading"
                  :loading="
                    isLoading &&
                    selectedChannel === 'whatsapp' &&
                    selectedPhone === user.full_phone_number
                  "
                  @click="sendReset('whatsapp', user.full_phone_number)"
                  small
                >
                  <v-icon small class="mr-1">mdi-whatsapp</v-icon>
                  WhatsApp
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
        <!-- No Phone Number Message -->
        <v-card outlined v-else>
          <v-card-text>
            <v-row align="center">
              <v-col cols="2">
                <v-icon size="30" color="grey">mdi-phone-off</v-icon>
              </v-col>
              <v-col cols="10">
                <div class="subtitle-1 text--disabled">No phone number available</div>
                <div class="caption text--disabled">SMS and WhatsApp options unavailable</div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="close" :disabled="isLoading">Cancel</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    isActive: { type: Boolean, default: false },
    user: { required: true, type: Object },
  },
  data: () => ({
    isLoading: false,
    selectedChannel: null,
    selectedPhone: null,
  }),
  computed: {
    emailAvailable() {
      return this.user.email && this.user.email.trim() !== "";
    },
  },
  methods: {
    async sendReset(channel) {
      this.isLoading = true;
      this.selectedChannel = channel;

      try {
        const payload = { channel };

        const result = await this.$http.post(
          `/api/v1/admin/users/${this.user.id}/pin/reset`,
          payload,
        );

        const channelName = this.getChannelDisplayName(channel);
        Notify.success(result.message || `PIN reset sent successfully via ${channelName}`);

        this.$emit("reset-sent", { channel, user: this.user });
        this.close();
      } catch (error) {
        const channelName = this.getChannelDisplayName(channel);
        Notify.error(error.message || `Failed to send PIN reset via ${channelName}`);
      } finally {
        this.isLoading = false;
        this.selectedChannel = null;
      }
    },
    getChannelDisplayName(channel, phoneNumber) {
      switch (channel) {
        case "email":
          return "Email";
        case "sms":
          return `SMS to ${phoneNumber}`;
        case "whatsapp":
          return `WhatsApp to ${phoneNumber}`;
        default:
          return channel;
      }
    },
    close() {
      this.$emit("update:isActive", false);
    },
  },
};
</script>
